"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySessionType = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../constants");
class StudySessionType {
    constructor(dayPlanDocId, moduleId, userId) {
        this.duration = 0;
        this.hasEnded = false;
        this.remainingAcquisitionTarget = 0;
        this.acquisitionProgress = 0;
        this.remainingReviewTarget = 0;
        this.reviewProgress = 0;
        this.remainingPracticeTarget = 0;
        this.practiceProgress = 0;
        this.highestCorrectStreak = 0;
        this.rightAcquisitionCount = 0;
        this.wrongAcquisitionCount = 0;
        this.rightReviewCount = 0;
        this.wrongReviewCount = 0;
        this.rightPracticeCount = 0;
        this.wrongPracticeCount = 0;
        this.dayPlanDocId = dayPlanDocId;
        this.moduleId = moduleId;
        this.userId = userId;
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_STUDY_SESSION;
    }
}
exports.StudySessionType = StudySessionType;
